import { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/site";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const touchStart = useRef(0);

  const go = useCallback((next: number) => {
    setIndex((next + heroSlides.length) % heroSlides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % heroSlides.length);
    }, 5500);
    return () => clearInterval(timer);
  }, []);

  const slide = heroSlides[index];

  return (
    <section
      className="relative w-full h-[440px] md:h-[600px] overflow-hidden"
      onTouchStart={(e) => { touchStart.current = e.touches[0].clientX; }}
      onTouchEnd={(e) => {
        const diff = e.changedTouches[0].clientX - touchStart.current;
        if (diff > 50) go(index - 1);
        else if (diff < -50) go(index + 1);
      }}
    >
      {heroSlides.map((s, i) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-700 ${i === index ? "opacity-100" : "opacity-0"}`}
        >
          <img
            src={s.image}
            alt={s.title}
            title={`${s.title} - 杨幂资讯`}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/50 to-foreground-950/25" />

      <div className="relative z-10 h-full w-full px-4 md:px-8 flex items-center">
        <div key={slide.id} className="max-w-2xl animate-marquee-in">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/95 text-primary-950 text-xs font-label font-semibold">
            <i className="ri-fire-line" />
            {slide.kicker}
          </span>
          <h1 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
            {slide.title}
          </h1>
          <p className="mt-4 text-sm md:text-base text-background-100/90 leading-relaxed max-w-xl">
            {slide.subtitle}
          </p>
          <div className="mt-7 flex items-center gap-3 flex-wrap">
            <Link
              to={slide.link}
              className="inline-flex items-center gap-2 px-6 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-label font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              查看详情
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/works"
              className="inline-flex items-center gap-2 px-6 h-11 rounded-md border border-background-50/40 text-background-50 text-sm font-label hover:bg-background-50/10 transition-colors whitespace-nowrap"
            >
              浏览作品库
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute z-10 bottom-6 right-4 md:right-8 flex items-center gap-2">
        {heroSlides.map((s, i) => (
          <button
            key={s.id}
            aria-label={`切换到第${i + 1}张`}
            onClick={() => go(i)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              i === index ? "w-8 bg-accent-500" : "w-3 bg-background-50/50 hover:bg-background-50/80"
            }`}
          />
        ))}
      </div>
    </section>
  );
}